import { BulkCapabilityResponse } from 'types/capabilities/capabilities'

export interface AccountCapabilities {
  isPrincipleCustomerCapabilityEnabled: boolean
  isBvnkNetworkCapabilityEnabled: boolean
}
/**
 * Custom hook to return account capabilities from the capabilities management service
 *
 * @param {string} accountReference - The account reference to fetch capabilities on an account level
 * @param {BulkCapabilityResponse} bulkCapabilities - The bulk wallet capabilities response.
 * @returns {AccountCapabilities} - Returns the account capabilities or null if not yet fetched.
 */
export const useAccountCapabilities = (
  accountReference: string,
  bulkCapabilities: BulkCapabilityResponse
) => {
  const isPrincipleCustomerCapabilityEnabled =
    bulkCapabilities?.ACCOUNT?.PRINCIPLE_CUSTOMER?.ACCOUNT?.[accountReference]?.value === 'true'

  const isBvnkNetworkCapabilityEnabled =
    bulkCapabilities?.NETWORK?.PARTICIPANT?.ACCOUNT?.[accountReference]?.value === 'true'

  return {
    isPrincipleCustomerCapabilityEnabled,
    isBvnkNetworkCapabilityEnabled,
  }
}
